import Challenges from "../../components/challenges";

export default function AddEditChallenges({ type, obj, route, quarter }) {
    console.log({ type, obj, route, quarter })
    return (
        <Challenges type={type} route={route} obj={obj} quarter={quarter} />
    );
}
